/* @flow */

import { createSelector } from '@reduxjs/toolkit';
import {
  getConversationId,
  hydrateConversation,
} from '@braindate/domain/lib/conversation/util';

import { getEntities } from 'src/shared/app/base/util/reduxUtils';

import type { Conversation } from '@braindate/domain/lib/conversation/type';
import type { State } from 'src/shared/core/type/reduxTypes';

const _getConversationId = (state, props: Object) => props.id;

export function _getNormalizedConversationByTopicId(
  state: State,
  { id: topicId }: { id: number },
): ?Object {
  // TODO: assert arguments

  const { conversations } = state.domain.entities;

  for (const id in conversations) {
    const conversation = conversations[id];

    if (conversation.topic === topicId) {
      return conversation;
    }
  }
}

export const getConversationById: (state: Object, props: Object) => any =
  createSelector([_getConversationId, getEntities], (id, entities): any => {
    if (id) {
      const conversation = hydrateConversation(parseInt(id, 10), entities);

      return conversation;
    }
  });

export const getTopicConversation: (
  state: State,
  props: { id: number },
) => ?Conversation = createSelector(
  [_getNormalizedConversationByTopicId, getEntities],
  (normalizedConversation: ?Object, entities: Object): ?Conversation => {
    if (normalizedConversation) {
      const castedConversation: Conversation = normalizedConversation;

      return hydrateConversation(
        getConversationId(castedConversation),
        entities,
      );
    }
  },
);
